export type PermissionResource =
  | 'Products'
  | 'Packages'
  | 'PrintRuns'
  | 'Templates'
  | 'Brands'
  | 'OrganizationManagement'
  | 'Imports'
  | 'Facilities'
  | 'UserManagement';

export const getResourceActions = (resource: PermissionResource): string[] => [
  `Read${resource}`,
  `Write${resource}`,
  `Admin${resource}`,
];

export const getWriteActions = (resource: PermissionResource): string[] => [
  `Write${resource}`,
  `Admin${resource}`,
];

export const getAdminAction = (resource: PermissionResource): string => `Admin${resource}`;

export const combineResourceActions = (...resources: PermissionResource[]): string[] =>
  resources.flatMap(getResourceActions);

export const getAvailableActions = (currentUser: any): string[] => Array.from(new Set([
  ...(currentUser?.roleActions || []),
  ...(currentUser?.permissions?.actions || []),
  ...(currentUser?.internalRoleActions || []),
].filter(Boolean)));
